// Schema.org BlogPosting JSON-LD for blog post detail pages.
//
// Blog records in Firebase carry no author field and no modified date, so:
//   - author/publisher are the SOLS Foundation Organization (org-authored
//     editorial content). When per-post Person authors are added to Firebase
//     later, swap `author` for a Person linked to the same publisher.
//   - dateModified mirrors datePublished (no edit timestamp exists in the data).

const SITE_URL = "https://sols.foundation";
const LOGO_URL = `${SITE_URL}/assets/logos/sols-foundation-logo.png`;

const ORGANIZATION = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "SOLS Foundation",
  url: SITE_URL,
  logo: {
    "@type": "ImageObject",
    url: LOGO_URL,
  },
};

interface ArticleSchemaInput {
  url: string; // full canonical URL of the post
  headline: string;
  description?: string;
  image?: string;
  datePublished?: string; // ISO-8601
}

export const buildArticleSchema = (input: ArticleSchemaInput) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "@id": `${input.url}#article`,
  mainEntityOfPage: { "@type": "WebPage", "@id": input.url },
  headline: input.headline,
  ...(input.description ? { description: input.description } : {}),
  ...(input.image ? { image: input.image } : {}),
  ...(input.datePublished
    ? { datePublished: input.datePublished, dateModified: input.datePublished }
    : {}),
  inLanguage: "en",
  author: ORGANIZATION,
  publisher: ORGANIZATION,
});
